import { AppIcon } from "client/Components";
import { AppImageDisplayInfo } from "client/Api/AppIcon/common";
import styles from "./CardAppIcon.module.less";
import {
	getReactColorAttributes,
} from "client_legacy/ndaw/appColor";
import { AppColorViewModel } from "client/Api/Apps/common";
import classNames from "classnames";
import { ReactElement } from "react";

type CardAppIconProps = {
	appColor: AppColorViewModel;
	icon: AppImageDisplayInfo;
};

export const CardAppIcon = (props: CardAppIconProps): ReactElement => {
	const { icon, appColor } = props;

	const { colorClass, colorStyle } = getReactColorAttributes(appColor);

	return (
		<div className={classNames(styles.root, colorClass)} style={colorStyle}>
			<AppIcon value={icon} color="inherit" />
		</div>
	);
};

CardAppIcon.displayName = "CardAppIcon";